module.exports = __webpack_public_path__ + "static/media/about.1eed2799.jpg";